import { Component, ChangeDetectionStrategy } from '@angular/core'

interface UudistuksenOminaisuus {
  ikoni: string
  avain: 'tekoaly' | 'toimittaja' | 'haku' | 'listaus' | 'selvitettavat'
}

@Component({
  selector: 'app-tositteet-uudistus-dialog',
  templateUrl: './tositteet-uudistus.dialog.html',
  styleUrls: ['./tositteet-uudistus.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TositteetUudistusDialog {
  readonly ominaisuudet: UudistuksenOminaisuus[] = [
    { ikoni: 'auto_awesome', avain: 'tekoaly' },
    { ikoni: 'sell', avain: 'toimittaja' },
    { ikoni: 'search', avain: 'haku' },
    { ikoni: 'format_list_bulleted', avain: 'listaus' },
    { ikoni: 'check_circle', avain: 'selvitettavat' },
  ]
}
